exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dividedbox_splitter_proxy{float:left;width:4px;display:none;cursor:e-resize;position:absolute;background-color:#f0f0f0;border:1px solid #99bbe8;filter:alpha(opacity=60);-moz-opacity:.6;-khtml-opacity:.6;opacity:.6;z-index:1000000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/FormItemDividedBoxStyle.css
// module id = 299
// module chunks = 1 2 3 4 5 7